import {
  ACTIVE_HOME_ICON,
  ACTIVE_SEARCH_ICON,
  ACTIVE_SETTINGS_ICON,
  ACTIVITY_BLACK,
  ACTIVITY_WHITE,
  DATA_REPORT_BLACK,
  DATA_REPORT_WHITE,
  INACTIVE_HOME_ICON,
  INACTIVE_SEARCH_ICON,
  INACTIVE_SETTINGS_ICON,
  NOTIFICATION_BLACK,
  NOTIFICATION_WHITE,
  USERS_ICON_BLACK,
  USERS_ICON_WHITE,
} from "../assets";
import ActivityLogs from "../features/admin/activityLogs";
import CourtStaffActivityLogs from "../features/courtstaff/activitylogs";
import AdminDashboard from "../features/admin/dashboard";
import DataReports from "../features/admin/dataReports";
import ManageCases from "../features/admin/manageCases";
import AdminSettings from "../features/admin/settings/settings";
import CourtSettings from "../features/courtstaff/settings";
import Users from "../features/admin/users";
import CourtStaffManageCases from "../features/courtstaff/cases";
import CourtStaffDashboard from "../features/courtstaff/dashboard";
import Dashboard from "../features/individual/dashboard";
import SearchDetails from "../features/individual/searchDetails";
import SearchHistory from "../features/individual/searchHistory";
import GlobalSettings from "../features/individual/settings";
import Notifications from "../features/courtstaff/notification";
import SearchResult from "../features/individual/searchResult";

export const individualRoutes = [
  {
    title: "Dashboard",

    component: Dashboard,
    path: "/individual",
  },
  {
    title: "Search History",

    component: SearchHistory,
    path: "/individual/search-history",
  },
  {
    title: "Settings",

    component: GlobalSettings,
    path: "/individual/settings",
  },
  {
    title: "Search details",

    component: SearchDetails,
    path: "/individual/search-details",
  },
  {
    title: "Search details",

    component: SearchResult,
    path: "/individual/search-result",
  },
];
export const individualSidebarData = [
  {
    title: "Dashboard",
    activeIcon: ACTIVE_HOME_ICON,
    inactiveIcon: INACTIVE_HOME_ICON,

    path: "/individual",
  },
  {
    title: "Search History",
    activeIcon: ACTIVE_SEARCH_ICON,
    inactiveIcon: INACTIVE_SEARCH_ICON,

    path: "/individual/search-history",
  },
  {
    title: "Settings",
    activeIcon: ACTIVE_SETTINGS_ICON,
    inactiveIcon: INACTIVE_SETTINGS_ICON,

    path: "/individual/settings",
  },
];
export const superAdminRoutes = [
  {
    title: "Dashboard",

    component: AdminDashboard,
    path: "/admin",
  },
  {
    title: "Manage Properties",

    component: ManageCases,
    path: "/admin/manage-cases",
  },
  {
    title: "Users",

    component: Users,
    path: "/admin/users",
  },

  {
    title: "Activity Logs",

    component: ActivityLogs,
    path: "/admin/activity-logs",
  },
  {
    title: "Settings",

    component: DataReports,
    path: "/admin/data-reports",
  },
  {
    title: "Settings",

    component: AdminSettings,
    path: "/admin/settings",
  },
];
export const superAdminSideBar = [
  {
    title: "Dashboard",
    activeIcon: ACTIVE_HOME_ICON,
    inactiveIcon: INACTIVE_HOME_ICON,

    path: "/admin",
  },
  {
    title: "Manage Properties",
    activeIcon: ACTIVE_SEARCH_ICON,
    inactiveIcon: INACTIVE_SEARCH_ICON,

    path: "/admin/manage-cases",
  },
  {
    title: "Users",
    activeIcon: USERS_ICON_WHITE,
    inactiveIcon: USERS_ICON_BLACK,

    path: "/admin/users",
  },

  {
    title: "Activity Logs",
    activeIcon: ACTIVITY_WHITE,
    inactiveIcon: ACTIVITY_BLACK,

    path: "/admin/activity-logs",
  },
  {
    title: "Data Reports",
    activeIcon: DATA_REPORT_WHITE,
    inactiveIcon: DATA_REPORT_BLACK,

    path: "/admin/data-reports",
  },
  {
    title: "Settings",
    activeIcon: ACTIVE_SETTINGS_ICON,
    inactiveIcon: INACTIVE_SETTINGS_ICON,

    path: "/admin/settings",
  },
];
export const courtRoutes = [
  {
    title: "Dashboard",

    component: CourtStaffDashboard,
    path: "/court-staff",
  },
  {
    title: "Manage Properties",

    component: CourtStaffManageCases,
    path: "/court-staff/manage-cases",
  },

  {
    title: "Activity Logs",

    component: CourtStaffActivityLogs,
    path: "/court-staff/activity-logs",
  },
  {
    title: "Data Reports",

    component: Notifications,
    path: "/court-staff/notifications",
  },
  {
    title: "Settings",

    component: CourtSettings,
    path: "/court-staff/settings",
  },
];
export const courtSidebarData = [
  {
    title: "Dashboard",
    activeIcon: ACTIVE_HOME_ICON,
    inactiveIcon: INACTIVE_HOME_ICON,

    path: "/court-staff",
  },
  {
    title: "Manage Properties",
    activeIcon: ACTIVE_SEARCH_ICON,
    inactiveIcon: INACTIVE_SEARCH_ICON,

    path: "/court-staff/manage-cases",
  },

  {
    title: "Activity Logs",
    activeIcon: ACTIVITY_WHITE,
    inactiveIcon: ACTIVITY_BLACK,

    path: "/court-staff/activity-logs",
  },
  {
    title: "Notifications",
    activeIcon: NOTIFICATION_WHITE,
    inactiveIcon: NOTIFICATION_BLACK,

    path: "/court-staff/notifications",
  },
  {
    title: "Settings",
    activeIcon: ACTIVE_SETTINGS_ICON,
    inactiveIcon: INACTIVE_SETTINGS_ICON,

    path: "/court-staff/settings",
  },
];

export const faqData = [
  {
    id: 1,
    question: "What is Anambra e-Lis Pendens?",
    answer:
      "Anambra e-Lis Pendens is a service that provides information on properties in Anambra State, Nigeria that may be subject to a lawsuit (lis pendens) or have other encumbrances. We help you make informed decisions about real estate by highlighting potential legal issues associated with a property.",
  },
  {
    id: 2,
    question: "What are the benefits of using Anambra e-Lis Pendens?",
    answer:
      "By searching our database, you can avoid unknowingly purchasing a property with legal issues, protect yourself from financial loss and future litigation and make informed choices about property investments.",
  },
  {
    id: 3,
    question: 'What does "lis pendens" mean?',
    answer:
      'Lis pendens is a Latin term meaning "suit pending." It refers to a lawsuit involving the ownership or rights to a specific property. A lis pendens notice is filed in the land registry to alert potential buyers of the ongoing legal dispute.',
  },
  {
    id: 4,
    question: "How do I search for properties on Anambra e-Lis Pendens?",
    answer:
      "You can search our database using various criteria, such as property address, certificate of occupancy number, or owner's name.",
  },
  {
    id: 5,
    question: "What information do the search results provide?",
    answer:
      "The search results will indicate if a property has a lis pendens or other encumbrances registered against it. It may also provide brief details about the nature of the lawsuit or encumbrance.",
  },
  {
    id: 6,
    question:
      "What if the search results show a lis pendens on a property I'm interested in?",
    answer:
      "If a property has a lis pendens, it's advisable to consult with a lawyer to understand the potential risks involved before proceeding with the purchase.",
  },
  {
    id: 7,
    question: "How do your Services work?",
    answer:
      "For sustainability, we are a paid service. For a fee we allow you to search our database for properties you might be interested in to find out if they may be the subject of a suit. Where there's a match, we provide you with the suit details or nature of known encumbrance on the property.",
  },
  {
    id: 8,
    question: "Do you offer any legal advice?",
    answer:
      "Anambra e-Lis Pendens is an informational service and does not provide legal advice. We recommend consulting with a qualified lawyer for legal guidance on specific property issues.",
  },
  {
    id: 9,
    question: "Do you help with filing lis pendens notices?",
    answer:
      "Our core function is searching for existing lis pendens filings. We may be able to provide information on the process of filing a lis pendens notice, but it's always best to consult with a lawyer for this purpose.",
  },
];

export const footer = [
  {
    title: "Services",
    links: [
      {
        title: "Property Litigation Search",
        link: "",
      },
      {
        title: "Certificate of Lis Pendens",
        link: "",
      },
      {
        title: "Search History Management",
        link: "",
      },
      {
        title: "Case Status Tracking",
        link: "",
      },
      {
        title: "Admin & Registrar Upload System",
        link: "",
      },
    ],
  },
  {
    title: "User Groups Served",
    links: [
      {
        title: "Property Buyers & Investors",
        link: "",
      },
      {
        title: "Legal Practitioners",
        link: "",
      },
      {
        title: "Real Estate Agencies",
        link: "",
      },
      {
        title: "Government & Judiciary",
        link: "",
      },
      {
        title: "Financial Institutions",
        link: "",
      },
      {
        title: "Land Administrators & Registries",
        link: "",
      },
    ],
  },
];
